var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { class: { "ta-c": _vm.smAndDown }, attrs: { cols: "12" } },
            [
              _c("label", { staticClass: "contact-info-header" }, [
                _vm._v("Contact Information"),
              ]),
            ]
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("smart-text-field", {
                attrs: { placeholder: "Name", required: true },
                model: {
                  value: _vm.contactInfo.name,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactInfo, "name", $$v)
                  },
                  expression: "contactInfo.name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("smart-text-field", {
                attrs: { placeholder: "Company", required: true },
                model: {
                  value: _vm.contactInfo.company,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactInfo, "company", $$v)
                  },
                  expression: "contactInfo.company",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("smart-text-field", {
                attrs: { placeholder: "Phone", required: true, phone: true },
                on: {
                  input: function (e) {
                    return _vm.formatPhoneOnInput(e)
                  },
                },
                model: {
                  value: _vm.contactInfo.phone,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactInfo, "phone", $$v)
                  },
                  expression: "contactInfo.phone",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("smart-text-field", {
                attrs: { placeholder: "Email", email: true, required: true },
                model: {
                  value: _vm.contactInfo.email,
                  callback: function ($$v) {
                    _vm.$set(_vm.contactInfo, "email", $$v)
                  },
                  expression: "contactInfo.email",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm.showError
        ? _c(
            "v-row",
            [
              _c(
                "v-col",
                { attrs: { cols: "12" } },
                [
                  _c(
                    "v-alert",
                    {
                      staticClass: "mt-2",
                      attrs: { color: "#f6123a", dense: "", outlined: "" },
                    },
                    [
                      _c(
                        "v-row",
                        { staticClass: "px-2", attrs: { align: "center" } },
                        [
                          _c(
                            "v-col",
                            { staticClass: "grow ta-l d-flex align-start" },
                            [
                              _c("img", {
                                staticClass: "mr-2",
                                staticStyle: { width: "24px" },
                                attrs: { src: _vm.ic_red_warning },
                              }),
                              _c("div", [
                                _c("label", { staticClass: "error-lbl" }, [
                                  _vm._v("Please fill in all required fields:"),
                                ]),
                                _c("div", { staticClass: "dark-text" }, [
                                  _c(
                                    "ul",
                                    { staticClass: "mt-2 mb-0 pl-4" },
                                    _vm._l(_vm.missingFields, function (field) {
                                      return _c("li", { key: field }, [
                                        _vm._v(" " + _vm._s(field) + " "),
                                      ])
                                    }),
                                    0
                                  ),
                                ]),
                              ]),
                            ]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }